<template>
  <div class="service-process-bar">
    <div
      class="bar-item"
      v-for="(item, index) in barData"
      :key="index"
      :style="{'z-index': 100 - index}"
      :class="{'is-cur': item.isCur, 'is-prev': item.isPrev}"
    >
      <!-- <div class="num">{{index + 1}}</div> -->
      <div class="text">{{item.label}}</div>
    </div>
  </div>
</template>

<script>
/**
 * serviceMethod进度条
 */

// 将配置转为进度条渲染用的数据
function confToProcessList(conf) {
  const ret = [];
  let temp = {};
  conf.forEach((item) => {
    if (!temp.label) {
      temp.label = item.levelText;
      temp.states = [item.state];
      return;
    }
    if (temp.label !== item.levelText) {
      ret.push({
        ...temp,
      });
      temp = {
        label: item.levelText,
        states: [item.state],
      };
    } else {
      temp.states.push(item.state);
    }
  });
  if (temp.states.length) {
    ret.push({
      ...temp,
    });
  }
  return ret;
}

export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    // 类型； caseOrder: 案例，  workOrder: 工单
    orderType: {
      type: String,
      default: 'caseOrder',
    },
    state: Number,
  },
  data() {
    return {};
  },
  computed: {
    // 案例状态-进度条配置
    caseStateConf() {
      return [
        {
          state: 20,
          label: this.$t('asm_service_process_bar.dai_shou_li'),
          level: 1,
          levelText: this.$t('asm_service_process_bar.shou_li'),
        },
        {
          state: 30,
          label: this.$t('asm_service_process_bar.yi_shou_li'),
          level: 1,
          levelText: this.$t('asm_service_process_bar.shou_li'),
        },
        {
          state: 40,
          label: this.$t('asm_service_process_bar.yi_fen_pei'),
          level: 2,
          levelText: this.$t('asm_service_process_bar.fen_pai'),
        },
        {
          state: 50,
          label: this.$t('asm_service_process_bar.yi_jie_dan'),
          level: 2,
          levelText: this.$t('asm_service_process_bar.fen_pai'),
        },
        {
          state: 60,
          label: this.$t('asm_service_process_bar.yi_chu_fa'),
          level: 3,
          levelText: this.$t('asm_service_process_bar.chu_li'),
        },
        {
          state: 70,
          label: this.$t('asm_service_process_bar.yi_dao_da'),
          level: 3,
          levelText: this.$t('asm_service_process_bar.chu_li'),
        },

        {
          state: 90,
          label: this.$t('asm_service_process_bar.yi_jie_jue'),
          level: 4,
          levelText: this.$t('Common.com_finish'),
        },
        {
          state: 91,
          label: this.$t('asm_service_process_bar.wei_jie_jue'),
          level: 4,
          levelText: this.$t('Common.com_finish'),
        },
        {
          state: 100,
          label: this.$t('asm_service_process_bar.yi_wan_cheng'),
          level: 4,
          levelText: this.$t('Common.com_finish'),
        },
        {
          state: 120,
          label: this.$t('asm_service_process_bar.yi_guan_bi'),
          level: 4,
          levelText: this.$t('Common.com_finish'),
        },
      ];
    },
    // 工单状态-进度条配置
    orderStateConf() {
      return [
        {
          state: 40,
          label: this.$t('asm_service_process_bar.dai_jie_dan'),
          level: 1,
          levelText: this.$t('asm_service_process_bar.jie_dan'),
        },
        {
          state: 50,
          label: this.$t('asm_service_process_bar.yi_jie_dan'),
          level: 1,
          levelText: this.$t('asm_service_process_bar.jie_dan'),
        },
        {
          state: 60,
          label: this.$t('asm_service_process_bar.yi_chu_fa'),
          level: 2,
          levelText: this.$t('asm_service_process_bar.yi_chu_fa')
        },
        {
          state: 70,
          label: this.$t('asm_service_process_bar.yi_dao_da'),
          level: 3,
          levelText: this.$t('asm_service_process_bar.chu_li'),
        },

        {
          state: 90,
          label: this.$t('asm_service_process_bar.yi_jie_jue'),
          level: 4,
          levelText: this.$t('Common.com_finish'),
        },
        {
          state: 91,
          label: this.$t('asm_service_process_bar.wei_jie_jue'),
          level: 4,
          levelText: this.$t('Common.com_finish'),
        },
        {
          state: 100,
          label: this.$t('asm_service_process_bar.yi_wan_cheng'),
          level: 4,
          levelText: this.$t('Common.com_finish'),
        },
        {
          state: 101,
          label: this.$t('asm_service_process_bar.yi_zhuan_dan'),
          level: 4,
          levelText: this.$t('Common.com_finish'),
        },
        {
          state: 120,
          label: this.$t('asm_service_process_bar.yi_guan_bi'),
          level: 4,
          levelText: this.$t('Common.com_finish'),
        },
      ];
    },
    barData() {
      if (!this.state) {
        return [];
      }
      const conf = this.orderType === 'caseOrder' ? this.caseStateConf : this.orderStateConf;
      const list = confToProcessList(conf);
      const curIndex = list.findIndex(item => item.states.includes(this.state));
      list.forEach((item, index) => {
        if (index < curIndex) {
          item.isPrev = true;
        }
        if (index === curIndex) {
          item.isCur = true;
        }
      });
      return list;
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {},
  created() { },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.service-process-bar {
  overflow: hidden;
  width: 100%;
  display: flex;
  height: 24px;

  border: 1px solid #eef2f8;
  border-radius: 12px;

  .bar-item {
    flex: 1;
    text-align: center;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    line-height: 22px;
    position: relative;

    &.is-prev {
      color: #ffffff;
      background: #0d9ae0;
      &::before {
        background: #0d9ae0;
        border-color: #fff;
        border-left: none;
        border-bottom: none;
      }
    }

    &.is-cur {
      color: #ffffff;
      background: #0a77ad;
      &::before {
        background: #0a77ad;
        border-color: #0a77ad;
      }
    }

    &::before {
      content: ' ';
      position: absolute;
      width: 20px;
      height: 20px;
      border: 1px solid #eef2f8;
      border-left-color: transparent;
      border-bottom-color: transparent;
      top: 0;
      right: -11px;
      transform: rotate(45deg);
    }

    &:last-child {
      &::before {
        display: none;
      }
    }

    &.is-prev {
      .num {
        border-color: #0d9ae0;
        color: #0d9ae0;
      }
      .text {
        color: #fff;
      }
    }

    &.is-cur {
      .num {
        border-color: #0d9ae0;
        background: #0d9ae0;
        color: #fff;
      }
    }
  }
}
</style>
